import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { roundToDecimalPlace } from 'utils/helpers';
import AgGrid from 'screens/components/advanced/AgGrid';
import moment from 'moment';

const DataGrid = ({ expandProductInfo }) => {
    // Redux State
    const { productSales, productSalesTotal: currentTotal } = useSelector(state => state.reports || {});
    const [rows, setRows] = useState(productSales.list || []);
    

    useEffect(() => {
        
    }, [productSales, currentTotal])

    

    const dateCell = ({ value }) => <span>{`${value != null ? moment(value).format('MMM D, YYYY hh:mm') : ""}`}</span>;
    const decimalCell = ({ value }) => <span>{value ? value.toFixed(1) : `0.00`}</span>;
    const dollarCell = ({ value }) => <span>{value ? `$${value.toFixed(2)}` : `$0.00`}</span>;
    const percentageCell = ({ value }) => <span>{`${roundToDecimalPlace(value, 2)}%`}</span>;
    const TextCell = ({ value }) => <span>{ value }</span>

    const columns =  [
        { headerName: "Product", field: "productName", sortable: true, minWidth: 250 },
    ];

    if (expandProductInfo) 
    {
        columns.push(
            { headerName: "Category", field: "isCannabis", sortable: true, minWidth: 120, cellRenderer: ({ value }) => <span>{ value? "Cannabis" : "Non-Cannabis" }</span>},
            { headerName: "Sub-Category", field: "category", sortable: true, minWidth: 120 },
            { headerName: "SKU", field: "sku", sortable: true, minWidth: 120 },
            { headerName: "UPC", field: "upc", sortable: true, minWidth: 120 },
            { headerName: "Lot Number", field: "lotNumber", sortable: true, minWidth: 120 },
            { headerName: "Weight (g or ml)", field: "weightPerUnit", sortable: true, minWidth: 80 },
        )
    }
    

    columns.push(
        { headerName: "Branch", field: "branchName", sortable: true, minWidth: 200 },
        { headerName: "Status", field: "status", sortable: true, minWidth: 120},
        { headerName: "Quantity", field: "quantity", sortable: true, minWidth: 80},
        { headerName: "Total Selling Price", field: "subtotalincludingdiscount", sortable: true, minWidth: 100, cellRenderer: dollarCell },
        { headerName: "Gross Sales", field: "grossSales", sortable: true, minWidth: 100, cellRenderer: dollarCell },
        { headerName: "Gross Profit", field: "grossProfit", sortable: true, minWidth: 100, cellRenderer: dollarCell },
        { headerName: "Gross Margin", field: "grossProfitMargin", sortable: true, minWidth: 100, cellRenderer: percentageCell },
        { headerName: "Total Cost", field: "totalCost", sortable: true, minWidth: 100, cellRenderer: dollarCell },
        { headerName: "Discount", field: "discountAmount", sortable: true, minWidth: 100, cellRenderer: dollarCell },
        { headerName: "Gross Margin", field: "grossProfitMargin", sortable: true, minWidth: 100, cellRenderer: percentageCell },
        { headerName: "Complete Date", field: "completedDate", sortable: true, minWidth: 160, cellRenderer: dateCell},
        { headerName: "Refund Date", field: "refundDate", sortable: true, minWidth: 160, cellRenderer: dateCell },
    )

    let { province: productProvince } = productSales || [];
    productProvince = productProvince ? [...new Set(productProvince.split(", "))] : []; // Split the result into array and remove duplicate values

    // Change to test with array not string
    if (productProvince.includes("BC") || productProvince.includes("British Columbia")) {
        columns.push(
            { headerName: "PST", field: "pst", sortable: true, minWidth: 100, cellRenderer: dollarCell },
            { headerName: "GST", field: "gst", sortable: true, minWidth: 100, cellRenderer: dollarCell },
            { headerName: "PST_Vape", field: "pstVape", sortable: true, minWidth: 100, cellRenderer: dollarCell },
        )
    } else if (productProvince.includes("AB") || productProvince.includes("Alberta")) {
        columns.push({ headerName: "GST", field: "gst", sortable: true, minWidth: 100, cellRenderer: dollarCell },)
    } else if (productProvince.includes("ON") || productProvince.includes("Ontario")) {
        columns.push({ headerName: "HST", field: "hst", sortable: true, minWidth: 100, cellRenderer: dollarCell })
    }

    columns.push(
        { headerName: "Recent PO#", field: "mostRecentPO", sortable: true, minWidth: 100 }
    )
    
    const defaultColDef = {
        flex: 1,
        filter: "agTextColumnFilter",
        floatingFilter: true
    };

    return (<AgGrid rows={productSales.list} columns={columns} defaultColDef={defaultColDef} />)
}

export default DataGrid;